import { ActivatedRouteSnapshot, ViewTransitionsFeatureOptions } from '@angular/router';
import { NAV_CONFIG } from '../../shell/navigation.config';
import { loginTransition } from '../auth/login-transition';
import { isNavigationOverview } from './navigation-context';

let activeTransition: ViewTransition | undefined;

function primaryPath(snapshot: ActivatedRouteSnapshot): string {
  const segments: string[] = [];
  for (let route: ActivatedRouteSnapshot | null = snapshot; route; route = route.firstChild) {
    segments.push(...route.url.map(segment => segment.path));
  }
  return '/' + segments.join('/');
}

/** Connect main-menu entry and directory/workspace changes without animating routine work. */
export const navigationTransition: ViewTransitionsFeatureOptions = {
  skipInitialTransition: true,
  onViewTransitionCreated: (info) => {
    const { from, to, transition } = info;
    const root = document.documentElement;
    // A new navigation may interrupt an animation whose finished promise is still pending.
    activeTransition = transition;
    root.removeAttribute('data-area-transition');
    root.removeAttribute('data-workspace-transition');

    const destination = primaryPath(to);
    const origin = primaryPath(from);
    const area = origin === '/home'
      && NAV_CONFIG.find(item => item.key !== 'settings' && item.overviewRoute === destination);
    const fromArea = NAV_CONFIG.find(item => origin === item.overviewRoute || origin.startsWith(item.overviewRoute + '/'));
    const toArea = NAV_CONFIG.find(item => destination === item.overviewRoute || destination.startsWith(item.overviewRoute + '/'));
    const workspaceChange = fromArea && fromArea === toArea
      && isNavigationOverview(from) !== isNavigationOverview(to);

    if ((!area && !workspaceChange) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      activeTransition = undefined;
      loginTransition.onViewTransitionCreated?.(info);
      return;
    }

    // This runs before the old snapshot; CSS names the selected title on both pages.
    if (area) {
      root.setAttribute('data-area-transition', area.key);
    } else {
      root.setAttribute('data-workspace-transition', isNavigationOverview(to) ? 'overview' : 'work');
    }
    const cleanup = () => {
      if (activeTransition === transition) {
        root.removeAttribute('data-area-transition');
        root.removeAttribute('data-workspace-transition');
        activeTransition = undefined;
      }
    };
    void transition.finished.then(cleanup, cleanup);
  },
};
